import { Draft, produce } from 'immer';
import { DesignerParams } from '@/types';
import { BasketAction, BasketActionTypes, BasketState } from './types';

const INITIAL_STATE: BasketState = {
  data: { items: [] },
  status: 'initial',
};

export const getInitialBasketState = (params: DesignerParams) =>
  produce<BasketState>(INITIAL_STATE, (draft) => {
    if (params.basketId) {
      draft.data.id = params.basketId;
    }
    return draft;
  });

export const basketReducer = produce((draft: Draft<BasketState>, action: BasketAction) => {
  switch (action.type) {
    case BasketActionTypes.SET_BASKET_STATUS:
      draft.status = action.status;
      return draft;
    case BasketActionTypes.SET_BASKET:
      draft.data = action.payload;
      draft.status = action.status;
      return draft;
    default:
      return draft;
  }
}, INITIAL_STATE);
